import React, { ReactElement } from 'react';
import { MultiInput } from './index';
import MultiInputControlsProps from './MultiInputControlsProps';
import { JustifiedAddButton } from './Buttons';

export interface Actions {
  add?: (e: React.MouseEvent<any>) => void;
  delete?: (e: React.MouseEvent<any>) => void;
  moveUp?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  moveDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function MultiInputControls<T>(props: MultiInputControlsProps<T>): ReactElement {
  const saveLines: T[] = props.lines || [];
  const addEnd = (e?: React.MouseEvent<HTMLButtonElement>): void => {
    if(e) {
      e.preventDefault();
    }
    const originalLines: T[] = [...saveLines];
    props.addNew(saveLines);
    if (props.onChange) {
      props.onChange(saveLines, [saveLines.length - 1], originalLines);
    }
  };


  while(saveLines.length < props.min) {
    addEnd();
  }

  return (
    <div className={'mic-container flex flex-column gap-4'}>
      <MultiInput<T> lines={saveLines} onChange={props.onChange}>
        {(line: T, onRowChange: (newValues) => void, idx: number, lines: T[], onAllChange: (newValues: any[], changedValues: any[], originals?: any[]) => void): ReactElement => {

          const toggleElements = (down: number, up: number): void => {
            const dElement: T = lines[down];
            const uElement: T = lines[up];
            lines[down] = uElement;
            lines[up] = dElement;
            props.sortCallback(dElement, uElement);
            onAllChange(lines, [dElement, uElement]);
          };

          // control actions
          const actions: Actions = {};

          if (props.max === undefined || lines.length < props.max) {
            actions.add = addEnd;
          }
          if (lines.length > (props.min || 0)) {
            actions.delete = (e: React.MouseEvent<any>): void => {
              e.preventDefault();
              onAllChange(lines.filter((_: T, index: number): boolean => index !== idx), [idx]);
            };
          }
          if (lines.length > 1 && lines.indexOf(line) > 0) {
            actions.moveUp = (e: React.MouseEvent<HTMLButtonElement>): void => {
              e.preventDefault();
              toggleElements(lines.indexOf(line), lines.indexOf(line) - 1);
            };
          }
          if (lines.length > 1 && lines.indexOf(line) < lines.length - 1) {
            actions.moveDown = (e: React.MouseEvent<HTMLButtonElement>): void => {
              e.preventDefault();
              toggleElements(lines.indexOf(line) + 1, lines.indexOf(line));
            };
          }

          return (
            <div className={'mic-element'} key={idx}>
              {props.renderLines(line, onRowChange, actions, idx, lines, onAllChange, !!props.hideAddButton, !!props.hideAddButton, !!props.sortable)}
            </div>
          );
        }}
      </MultiInput>
      {(!props.hideAddButton && (!props.max || saveLines.length < props.max)) &&
        <JustifiedAddButton onClick={addEnd} disabled={(props.max && !(saveLines.length < props.max))}/>}
    </div>
  );
}
